import { render, staticRenderFns } from "./CategoryArticle.vue?vue&type=template&id=b0e01d20"
import script from "./CategoryArticle.vue?vue&type=script&lang=ts"
export * from "./CategoryArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports